export default __webpack_public_path__ + "static/media/01__o_preview_5.f5903322.jpg";